import React from 'react';

const ShippingDelivery = () => (
  <div>
    <div className="page-header">
      <div className="container"><h1>Shipping &amp; Delivery</h1><p>Getting your order to you, safely and on time</p></div>
    </div>
    <div className="policy-content">
      <h2>Processing Time</h2>
      <p>Orders are processed within 1–2 business days of confirmation. Every bag, jerkin and trolley is packed to prevent damage in transit — trolleys ship in protective outer cartons.</p>

      <h2>Delivery Timeline</h2>
      <p>Standard delivery typically takes 3–7 business days depending on your location and product availability. Delivery estimates are shown at checkout and may vary for remote areas.</p>

      <h2>Shipping Charges</h2>
      <p>Shipping charges, if any, are calculated at checkout based on your order and payment method. Cash-on-Delivery orders may carry a small handling fee.</p>

      <h2>Order Tracking</h2>
      <p>Once your order is dispatched, you can track it from your account under My Orders, or via the Track Order page using your Order ID or phone number.</p>

      <h2>Failed Deliveries</h2>
      <p>If a delivery attempt fails, our courier partner will typically re-attempt over the next 1–2 days. If an order is returned to us undelivered, we will contact you to arrange re-shipment or a refund.</p>
    </div>
  </div>
);

export default ShippingDelivery;
